export const report_status_transition = { // 'from' => 'to'
    'leg': {
        'new': { name: 'nuovo', next: ['measuring', 'failed', 'deleted'] },
        'measuring': { name: 'in corso', next: ['measuring', 'completed', 'completed_failed', 'deleted'] },
        'completed': { name: 'misure complete', next: ['revising', 'reviewed', 'deleted'] },
        'completed_failed': { name: 'misure non conformi', next: ['failed', 'revising', 'deleted'] },
        'revising': { name: 'da rivedere', next: ['revised'] },
        'reviewed': { name: 'revisione conclusa', next: ['ready', 'deleted'] },
        //'op_signed':['reviewed'],
        'failed': { name: 'revisione fallita', next: ['ready_failed'] },
        'deleted': { name: 'eliminato', next: [] },
        'ready': { name: 'pdf pronto', next: ['signed'] }, // ['xml_created'],
        'ready_failed': { name: 'pdf (fallito) pronto', next: ['signed'] },
        'revised': { name: 'rivisto', next: [] },
        'signed': { name: 'firmato', next: []}
        //'xml_created': ['xml_signed'],
        //'xml_signed': ['xml_sent'],
        //'xml_sent': []
    },
    'iso': {
        'new': { name: 'nuovo', next: ['measuring', 'failed', 'deleted'] },
        'measuring': { name: 'in corso', next: ['measuring', 'completed', 'failed', 'deleted'] }, //, 'reviewed'],
        'completed': { name: 'misure complete', next: ['ready', 'deleted'] }, // , 'reviewed'],
        //'reviewed': ['ready', 'failed'],
        'failed': { name: 'misure non conformi', next: ['ready_failed'] },
        'deleted': { name: 'eliminato', next: [] },
        'ready': { name: 'report pronto', next: ['signed'] },
        'ready_failed': { name: 'report fallito pronto', next: ['signed'] },
        'signed': { name: 'firmato', next: []}

    },
    'iso_simple': {
        'new': { name: 'nuovo', next: ['measuring', 'deleted'] },
        'measuring': { name: 'in corso', next: ['measuring', 'completed', 'completed_failed', 'deleted'] },
        'completed': { name: 'misure complete', next: ['revising', 'reviewed', 'deleted'] }, //' 
        'completed_failed': { name: 'misure fallite', next: ['failed', 'revising', 'deleted'] },
        'revising': { name: 'da rivedere', next: ['revised'] },
        'reviewed': { name: 'revisione conclusa', next: ['ready', 'deleted'] },
        'failed': { name: 'revisione fallita', next: ['ready_failed'] },
        'deleted': { name: 'eliminato', next: [] },
        'revised': { name: 'rivisto', next: [] },
        'ready': { name: 'pdf pronto', next: ['signed'] },
        'ready_failed': { name: 'pdf (fallito) pronto', next: ['signed'] },
        'signed': { name: 'firmato', next: []}
    },
    'lat': {
        'failed': { name: 'misure fallite', next: ['ready_failed'] },
        'ready_failed': { name: 'pdf (fallito) pronto', next: [] },
        'deleted': { name: 'eliminato', next: [] },
        'ready': { name: 'pdf pronto', next: [] },
        'signed': { name: 'firmato', next: []}
    }
}

export const revision_status = {
    'leg': ['completed', 'completed_failed'],
    'iso_simple': ['completed', 'completed_failed'],
}

export const pdf_generations_status = {
    'leg': ['reviewed', 'failed'],
    'iso': ['completed', 'failed'],
    'iso_simple': ['reviewed', 'failed'],
    'lat': ['reviewed', 'failed']
}


export const filter_report_management = {
    'leg': ['new', 'measuring', 'revising', 'reviewed', 'failed', 'completed', 'completed_failed'],
    'iso': ['new', 'measuring', 'failed', 'completed', 'completed_failed'],
    'iso_simple': ['new', 'measuring', 'revising', 'reviewed', 'failed', 'completed', 'completed_failed'],
    'lat': ['reviewed', 'failed']
}

export function getClosingStatus(op_type) {
    let status = Object.keys(report_status_transition[op_type])
    let closing = []
    for (let st of status.next) {
        if (report_status_transition[op_type][st].length == 0) {
            closing.push(st)
        }
    }
    console.log('closing', closing)
    return closing
}

export function getReportAllowedStatus(op_type, current) {
    return report_status_transition[op_type][current].next
}
export function rStatusCanChange(op_type, current_s, new_s) {
    return report_status_transition[op_type][current_s].next.includes(new_s)
}

export const operation_status_transition = {
    'new': ['working', 'deleted'],
    'working': ['working', 'closed', 'deleted'],
    'deleted': [],
    'closed': []
}

export function getOperationAllowedStatus(current) {
    return operation_status_transition[current]
}

export function oStatusCanChange(current_s, new_s) {
    return operation_status_transition[current_s].includes(new_s)
}

export function isReopenable(current) {
    // var reopenable = false
    // switch (current) {
    //     case 'completed': 
    //     case 'completed_failed': 
    //     case 'reviewed':
    //     case 'failed':
    //         reopenable = true;
    //         break;
    //     default:
    //         reopenable = false;
    // }
    // return reopenable
    return true
}
